import React,{useState} from 'react'

export default function TitleCaptionDescription(params) {
    const [title] = useState(params.title)
    const [caption] = useState(params.caption)
    const [side] = useState( params.side ? params.side : "left")
    const [marginTop] = useState(params.marginTop ? params.marginTop: "5px")
    const [size, setSize] = useState(params.size ? params.size : "18px")
    return (
        <>
            {side==="left" ? 
            <div style={{borderLeft:"3px solid black",textAlign:side,padding:"5px" , marginTop:marginTop}}>
                <div className="title" style={{fontWeight:"bold", fontSize:size}}>{title}</div>
                <div className="caption">{caption}</div>
            </div>
            : <div style={{borderRight:"3px solid black",textAlign:side,padding:"5px" , marginTop:marginTop}}>
                <div className="title" style={{fontWeight:"bold", fontSize:size}}>{title}</div>
                <div className="caption">{caption}</div>
            </div>}
            <div style={{textAlign:side}}>
                {params.children}
            </div>
        </>   
    )
}